<template>
  <div class="ConjugeSV">
    <div class="row align-items-end">
      <div class="col-3">
        <div class="form-group">
          <label :for="`propPessoa_cpf_${ propIndex }`"
                 class="label">
            CPF
          </label>
          <div class="input-group">
            <input :id="`propPessoa_cpf_${ propIndex }`"
                   ref="cpf_conjuge"
                   v-model="propPessoa.cpf"
                   v-mask="{ mask:'999.999.999-99' }"
                   v-validate="{ regex: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/, min: 14, max: 14 }"
                   maxlength="14"
                   minlength="14"
                   :disabled="!!propPessoa.cpf_sem_inscricao"
                   type="tel"
                   name="cpf_conjuge"
                   class="form-control form-control-sm"
                   :class="{ 'is-invalid': errors.has('cpf_conjuge') }"
                   @change="searchCPF()">
            <div class="input-group-append">
              <button class="btn btn-sm btn-primary"
                      :disabled="!!propPessoa.cpf_sem_inscricao"
                      @click="showModal = true">
                Averbar
              </button>
            </div>
          </div>
          <small v-if="errors.has(`cpf_conjuge`)"
                 class="text-danger">
            {{ errors.first(`cpf_conjuge`) }}
          </small>
        </div>
      </div>

      <div class="col">
        <div class="form-group">
          <span class="custom-control custom-switch">
            <input
              :id="`propPessoa_desconhecida${ propIndex }`"
              ref="sem_inscricao"
              v-model="propPessoa.cpf_sem_inscricao"
              class="custom-control-input"
              name="tipo_registro"
              type="checkbox"
              :value="1"
              @change="propPessoa.cpf = null">
            <label
              class="custom-control-label"
              :for="`propPessoa_desconhecida${ propIndex }`">Sem inscrição</label>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label :for="`propPessoa_nome_${ propIndex }`"
                 class="label">
            Nome <span class="text-danger">*</span>
          </label>
          <input :id="`propPessoa_nome_${ propIndex }`"
                 v-model.lazy="propPessoa.nome_antigo"
                 v-validate="'required'"
                 v-uppercase
                 type="text"
                 class="form-control form-control-sm text-uppercase"
                 :class="{'is-invalid': errors.has(`propPessoa_nome_${ propIndex }`)}"
                 :name="`propPessoa_nome_${ propIndex }`"
                 @change="changeNames()">
          <small v-if="errors.has(`propPessoa_nome_${ propIndex }`)"
                 class="text-danger">
            {{ errors.first(`propPessoa_nome_${ propIndex }`) }}
          </small>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label :for="`propPessoa_novo_nome_${ propIndex }`"
                 class="label">
            Novo nome
          </label>
          <input :id="`propPessoa_novo_nome_${ propIndex }`"
                 v-model.lazy="propPessoa.nome"
                 v-uppercase
                 type="text"
                 class="form-control form-control-sm text-uppercase"
                 name="propPessoa_nome"
                 @change="changeNames()">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <div class="form-group">
          <label class="label"
                 :for="`propPessoa_sexo_${ propIndex }`">Sexo
          </label>
          <div class="m-0 p-0">
            <v-select :id="`propPessoa_sexo_${ propIndex }`"
                      v-model="propPessoa.sexo"
                      class="form-control form-control-sm"
                      label="name"
                      :reduce="sexo => sexo.value"
                      :options="options.SEXOS" />
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="form-group">
          <label :for="`propPessoa_data_nascimento_${ propIndex }`"
                 class="label">
            Data de Nascimento
          </label>
          <input :id="`propPessoa_data_nascimento_${ propIndex }`"
                 v-model="propPessoa.data_nascimento"
                 v-validate="`date_format:yyyy-MM-dd|date_between:1500-01-01,${limitDate}`"
                 :name="`propPessoa_data_nascimento_${ propIndex }`"
                 type="date"
                 class="form-control form-control-sm"
                 :class="{'is-invalid': errors.has(`genitor_data_nascimento_${propIndex}}`) || !!propPessoa.data_nascimento && propPessoa.idade < 14 }"
                 @change="nascimentoHandler()">
          <small v-if="errors.has(`genitor_data_nascimento_${ propIndex }`)"
                 class="text-danger">
            {{ errors.first(`genitor_data_nascimento_${ propIndex }`) }}
          </small>
          <small v-else-if="!!propPessoa.data_nascimento && propPessoa.idade < 14"
                 class="text-danger">
            Idade menor que o permitido para realização do casamento.
          </small>
        </div>
      </div>
      <div v-if="false"
           class="col-4">
        <div class="form-group">
          <label :for="`propPessoa_estado_civil_${ propIndex }`"
                 class="label">
            Estado Civil
          </label>
          <select :id="`propPessoa_estado_civil_${ propIndex }`"
                  v-model="propPessoa.estado_civil"
                  class="custom-select custom-select-sm"
                  name="estado_civil">
            <option v-for="(estado, ind) in options.ESTADOS_CIVIL_HABILITACAO.filter(est => (propPessoa.sexo && propPessoa.sexo !='I' ) ? est.genero == propPessoa.sexo : est.name )"
                    :key="ind"
                    :value="estado.value">
              {{ estado.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-3">
        <div class="form-group">
          <label class="label"
                 for="propPessoa_nacionalidade">Nacionalidade
          </label>
          <div class="m-0 p-0">
            <Nacionalidades v-model="propPessoa.nacionalidade_codigo"
                            :prop-nacionalidade="propPessoa.nacionalidade"
                            :prop-sexo="propPessoa.sexo"
                            class="m-0 p-0"
                            @updated="changeNacionalidade" />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div v-if="propPessoa.nacionalidade_codigo === 76"
           class="col-2">
        <div class="form-group">
          <label class="label"
                 :for="`propPessoa_uf_${ propIndex }`">UF</label>
          <select :id="`propPessoa_uf_${ propIndex }`"
                  v-model="propPessoa.uf"
                  class="form-control form-control-sm"
                  @change="filterCities">
            <option :value="null">
              Selecione um estado:
            </option>
            <option v-for="estado in options.estados"
                    :key="`${ propIndex }_${ estado.uf }`">
              {{ estado.uf }}
            </option>
          </select>
        </div>
      </div>

      <div v-if="show.naturalidade"
           class="col-3">
        <div class="form-group">
          <label class="label"
                 :for="`propPessoa_naturalidade_${ propIndex }`">Naturalidade
          </label>
          <div class="m-0 p-0">
            <v-select :id="`propPessoa_naturalidade_${ propIndex }`"
                      v-model="propPessoa.naturalidade"
                      :options="options.cidades.map(cidade => cidade.nome)"
                      :show-labels="false"
                      :searchable="pessoa.uf !== 'EX'"
                      :taggable="propPessoa.uf !== 'EX'"
                      placeholder="Selecione" />
          </div>
        </div>
      </div>

      <div v-if="showNatDeclarada"
           class="col-4 col-sm-6">
        <div class="form-group">
          <label class="label"
                 :for="`naturalidade_declarada_${ propIndex }`">Naturalidade declarada
          </label>
          <input id="naturalidade_declarada"
                 v-model="propPessoa.naturalidade_declarada"
                 class="form-control form-control-sm"
                 name="naturalidade_declarada"
                 type="text">
        </div>
      </div>
    </div>
    <div class="SegundaViaCasamento_body_header mb-2">
      Genitores
    </div>
    <div v-for="(genitor, ind) in propPessoa.genitores"
         :key="ind">
      <GenitorSVCasamento :prop-genitor="genitor"
                          :prop-index-pessoa="propIndex"
                          :prop-index-genitor="ind"
                          @removeGenitor="removeGenitor(ind)" />
    </div>
    <div class="row">
      <div class="col-12">
        <button class="btn btn-sm btn-outline-primary btn-block btn-new-genitor"
                @click="newGenitor()">
          <IconSvg class="icon-add icon--sm mr-1"
                   icon="add" />
          Adicionar genitor
        </button>
      </div>
    </div>

    <b-modal v-if="showModal"
             :visible="true"
             centered
             size="xl"
             no-close-on-backdrop
             no-close-on-esc
             :hide-header="true"
             :hide-footer="true">
      <AverbacaoSV :prop-cpf="propPessoa.cpf"
                   :registro-id="propCasamento.registro.registro_id"
                   :prop-transporte="propCasamento.registro.transporte"
                   @hideModal="showModal = false" />
    </b-modal>
  </div>
</template>

<script>
  /* components */
  import Nacionalidades from "@/components/SofiaRei/Nacionalidades"
  import GenitorSVCasamento from "./GenitorSVCasamento"
  import AverbacaoSV from '@/components/SofiaRei/Nascimento/SegundaVia/AverbacaoSV'

  /* constants */
  import SEXOS from "@/constants/sexos"
  import brazilianStates from "@/constants/brazilianStates"
  import { ESTADOS_CIVIL_HABILITACAO } from "@/constants/estadosCivil"
  import Cidades from "@/constants/repositorio/cidades"

  /* services */
  import PessoasService from "@/services/Pessoas"

  /* filters */
  import { filterDate,filterMaskedNumber, maskCPF } from '@/filters/filters'

  /* outros */
  import moment from "moment"

  export default {
    name: 'ConjugeSV',
    components: {
      Nacionalidades,
      GenitorSVCasamento,
      AverbacaoSV
    },
    inject: ['$validator'],
    props: {
      propPessoa: { type: Object, default: () => ({})},
      propCasamento: { type: Object, default: () => ({})},
      propIndex: { type: Number, default: 0}
    },
    data () {
      return {
        show: {
          naturalidade: false,
          idade: false
        },
        constants: {
          brazilianCities: []
        },
        options: {
          SEXOS,
          ESTADOS_CIVIL_HABILITACAO,
          estados: brazilianStates,
          cidades: []
        },
        limitDate: moment(new Date()).add(1, 'day').format('YYYY-MM-DD'),
        showModal: false
      }
    },
    computed: {
      showNatDeclarada () {
        let { nacionalidade_codigo } = this.propPessoa

        if (nacionalidade_codigo && nacionalidade_codigo != 76) {
          return true
        }

        return (this.propPessoa.naturalidade === 'Outro')
      }
    },
    watch: {
      'propPessoa.estado_civil' () {
        this.verifyEstadoCivil()
      }
    },
    async created () {
      this.constants.brazilianCities = Cidades
      if (this.constants && this.constants.brazilianCities.length) this.filterCities()

      this.init()
    },
    mounted () {
      this.verifyEstadoCivil()
    },
    methods: {
      init () {
        if (!this.propPessoa.novo_antigo && this.propPessoa.pivot) {
          this.propPessoa.novo_antigo = this.propPessoa.pivot.nome_antigo
        }

        if (this.propPessoa.nacionalidade_codigo != 76) {
          this.show.naturalidade = false
        } else {
          this.show.naturalidade = true
        }

        this.calculateAge()

        if (this.propPessoa.uf !== 'EX') this.filterCities()

        if (this.propPessoa.cpf) this.propPessoa.cpf = maskCPF(this.propPessoa.cpf)
      },
      changeNames () {
        if (this.propPessoa.nome_antigo) this.propPessoa.nome_antigo = this.propPessoa.nome_antigo.toUpperCase()
        if (this.propPessoa.nome) this.propPessoa.nome = this.propPessoa.nome.toUpperCase()
      },
      filterCities () {
        if (!this.propPessoa.uf) return

        if (this.propPessoa.uf === 'EX') {
          this.options.cidades = []

          this.options.cidades.push({nome: 'Outro'})
          this.propPessoa.naturalidade = 'Outro'

          return
        }

        const state = this.options.estados.find(estado => estado.uf == this.propPessoa.uf)
        const cities = Cidades.filter(cidade => cidade.codigo_uf == state.ibgeId)

        cities.push({nome: 'Outro'})

        this.options.cidades = cities
      },
      async searchCPF () {
        let cpf = filterMaskedNumber(this.propPessoa.cpf)

        if (cpf && cpf.length > 10) {
          const dados = await PessoasService.getPessoaByCPF(cpf)

          if (dados.isEmpty) return

          const { nome, datanascimento, sexo, nomemae } = dados

          const sexos = {
            1: 'M',
            2: 'F'
          }

          if (nomemae) {
            // deixando sexo feminino temporário para se adaptar ao que vem da CRC
            const mother = this.propPessoa.genitores.find(genitor => genitor.pessoa.nome == nomemae)
            if (!mother) {
              this.propPessoa.genitores.push({ pessoa: { nome: nomemae, sexo: "F" } })
            }
          }

          this.propPessoa.nome_antigo = nome

          let dataNascimento = filterDate(datanascimento)

          this.propPessoa.data_nascimento = dataNascimento.split('/').reverse().join('-')

          this.calculateAge()
          this.changeNames()

          this.propPessoa.sexo = sexos[sexo] || 'I'
        }

        this.propPessoa.cpf = this.propPessoa.cpf || null
      },
      nascimentoHandler () {
        if (!this.propPessoa.data_nascimento) this.propPessoa.data_nascimento = null

        this.calculateAge()
      },
      calculateAge () {
        this.show.idade = false

        let dataComparacao = moment()

        if (this.propCasamento && this.propCasamento.registro && this.propCasamento.registro.data_registro) {
          dataComparacao = this.propCasamento.registro.data_registro
        }

        this.propPessoa.idade = moment(dataComparacao).diff(moment(this.propPessoa.data_nascimento), 'years')
        this.show.idade = true
      },
      verifyEstadoCivil () {
        if (this.propPessoa.estado_civil && this.propPessoa.sexo === 'F') {
          this.tratarEstadoCivil(this.propPessoa.estado_civil)
        }
      },
      tratarEstadoCivil (estado) {
        switch (estado) {
        case 'SOLTEIRA':
          this.propPessoa.estado_civil = 'SOLTEIRO'
          break
        case 'VIÚVA':
          this.propPessoa.estado_civil = 'VIUVO'
          break
        case 'DIVORCIADA':
          this.propPessoa.estado_civil = 'DIVORCIADO'
          break
        case 'IGNORADA':
          this.propPessoa.estado_civil = 'IGNORADO'
          break
        case 'OUTRAS':
          this.propPessoa.estado_civil = 'OUTROS'
          break
        }
      },
      changeNacionalidade (nacionalidade) {
        this.propPessoa.nacionalidade = nacionalidade

        if (this.propPessoa.nacionalidade.nome === "Brazil" || this.propPessoa.nacionalidade.nome === "Brasil") {
          this.propPessoa.uf = null
          this.show.naturalidade = true
          this.propPessoa.naturalidade_declarada =  null
        } else {
          this.propPessoa.naturalidade = null
          this.show.naturalidade = false
          this.propPessoa.uf = "EX"
        }
      },
      newGenitor () {
        this.propPessoa.genitores.push({
          filiacao: [
            { nome: '' },
            { nome: '' }
          ],
          localOcorrenciaFalecimento: {
            tipo: 'OUTRO',
            endereco: {}
          },
          pessoa: {
            cpf: null,
            sexo: null,
            nome: null,
            endereco: {},
            documentos: [],
            data_nascimento: null,
            idade: 0,
            codigo_ocupacao: [],
            nacionalidade_codigo: 76,
            nacionalidade: {
              nacionalidade_codigo: 76,
              nome: 'Brasil',
              nome_masculino: 'brasileiro',
              nome_feminino: 'brasileira'
            },
            falecido: false
          },
          declarante: false
        },)
      },
      removeGenitor (index) {
        const { genitores } = this.propPessoa

        if (genitores[index] && genitores[index].genitor_id) {
          this.$emit('removeGenitor',genitores[index].genitor_id)
        }

        this.propPessoa.genitores.splice(index, 1)
      }
    }
  }
</script>

<style lang="scss">

</style>
